import {createI18n} from 'vue-i18n';

function loadLocaleMessages() {
    const context = require.context("./locales", true, /[A-Za-z0-9-_,\s]+\.js$/i);
    const messages = {};
    context.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\.js$/i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = context(key).default;
        }
    });
    return messages;
}

const i18n = createI18n({
    legacy: false, // Important: Specify the Vue 3 composition API mode
    warnHtmlMessage: false, // to not show warning regarding html inside t
    locale: process.env.VUE_APP_I18N_LOCALE || "de",
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "de",
    messages: loadLocaleMessages()
});

export default i18n;

// Necessary for autoimport. Used in webpack.config.js
export const t = (...args) => (i18n.global).t(...args);
export const useT = () => (i18n.global).t;
